module.exports = __webpack_public_path__ + "img/preview_sku_bg_b2b.6729706c.png";